module.exports = __webpack_public_path__ + "static/media/logoFull.c0dcd6e5.svg";